export default __webpack_public_path__ + "static/media/right-hex-f0157e5822cb4b72e328cdfb4b996134.png";